import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTERS } from './consts';

export const getBugReports = path([$, LIST]);
export const getBugReport = (id) => path([$, LIST, id]);
export const getBugReportProp = (id) => (name) => path([$, LIST, id, name]);
export const getBugReportsFilters = path([$, FILTERS]);
